import Image from 'next/image'
import Link from 'next/link'

export const Logo = () => (
  <Link href="/" className="relative flex items-center">
    <Image
      src="/images/logo-24h@2x.png"
      alt="RankSurf"
      width={131}
      height={24}
      priority
      className="dark:hidden"
    />
    <Image
      src="/images/logo-24h-dark@2x.png"
      alt="RankSurf"
      width={131}
      height={24}
      priority
      className="hidden dark:block"
    />
  </Link>
)
